import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["count"]
    static values = {
        refreshInterval: { type: Number, default: 60000 } // 60 seconds by default
    }

    connect() {
        // Set up visibility change listener
        this.visibilityChangeHandler = this.handleVisibilityChange.bind(this)
        document.addEventListener('visibilitychange', this.visibilityChangeHandler)

        // Only start refreshing if the page is visible
        if (!document.hidden) {
            this.startRefreshing()
        }

        // Also refresh immediately on connect if the page is visible
        if (!document.hidden) {
            this.refreshCount()
        }
    }

    disconnect() {
        // Clean up when controller disconnects
        this.stopRefreshing()
        document.removeEventListener('visibilitychange', this.visibilityChangeHandler)
    }

    handleVisibilityChange() {
        if (document.hidden) {
            // Tab is hidden, stop refreshing
            this.stopRefreshing()
        } else {
            // Tab is visible again, refresh immediately and restart the timer
            this.refreshCount()
            this.startRefreshing()
        }
    }

    startRefreshing() {
        // Clear any existing timer first to avoid duplicates
        this.stopRefreshing()

        this.refreshTimer = setInterval(() => {
            this.refreshCount()
        }, this.refreshIntervalValue)
    }

    stopRefreshing() {
        if (this.refreshTimer) {
            clearInterval(this.refreshTimer)
            this.refreshTimer = null
        }
    }

    refreshCount() {
        fetch('/notifications/unread-count', {
            headers: {
                'Accept': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            }
        })
            .then(response => response.json())
            .then(data => {
                if (data.count > 0) {
                    // If there are unread notifications, update and show the count element
                    this.countTarget.textContent = data.count > 99 ? "99+" : data.count
                    this.countTarget.classList.remove('hidden')
                } else {
                    // If there are no unread notifications, hide the count element
                    this.countTarget.classList.add('hidden')
                }
            })
            .catch(error => {
                console.error('Error fetching notification count:', error)
            })
    }
} 